import { Component } from 'react'
import { connect } from 'react-redux'
import * as PIXI from 'pixi.js-legacy'
import PropTypes from 'prop-types'

import { getUI } from 'common/core/selectors/uiSelectors'

import app from './app'
import { MIN_DRAG_DELTA, STATES } from './config'
import Rect from './shapes/Rect'

class FlowSelection extends Component {
  static propTypes = {
    selected: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired,
    onMergeSelect: PropTypes.func,
    hideSidebar: PropTypes.func,
  }

  static defaultProps = {
    onMergeSelect: () => {},
    hideSidebar: () => {},
  }

  _mouseDownX = 0
  _mouseDownY = 0
  _selectionStarted = false

  componentDidMount() {
    const { stage } = app.root
    stage
      .on('click', this.handleStageClick)
      .on('tap', this.handleStageClick)
      .on('mousedown', this.handleStageMouseDown)
      .on('mouseup', this.handleStageMouseUp)
      .on('mouseupoutside', this.handleStageMouseUp)
      .on('mousemove', this.handleStageMouseMove)

    app.addZoomBlocker((_) => app.state === STATES.SELECTING_FRAME)

    this.frame = new Rect({ stroke: 0x0084ff, background: 0x0084ff, alpha: 0.3 })
  }

  handleStageClick = async (e) => {
    if (e.target !== e.currentTarget) {
      return
    }

    // Dropping hover for touch devices
    app.dropHover()

    const { originalEvent } = e.data
    if (originalEvent.shiftKey) {
      return
    }

    if (e.data.mouseDragDelta > MIN_DRAG_DELTA) {
      return
    }

    if (await this.props.onSelect()) {
      this.props.hideSidebar()
    }
  }

  handleStageMouseDown = (e) => {
    // Temp hack. Or not?
    delete e.$drag

    if (e.target !== e.currentTarget) {
      return
    }

    // Prevent creating frame selection when creating new connector

    if (app.state === STATES.CREATING_NEW_CONNECTOR || app.state === STATES.PANNING) {
      return
    }

    const local = e.data.getLocalPosition(app.root.stage)
    this._mouseDownX = local.x
    this._mouseDownY = local.y

    const { originalEvent } = e.data

    if (!originalEvent.shiftKey) {
      return
    }

    if (!this.props.isHeaderEditing) {
      originalEvent.preventDefault && originalEvent.preventDefault()
    }
    app.state = STATES.SELECTING_FRAME
    app.root.stage.addChild(this.frame.ctx)
  }

  handleStageMouseMove = (e) => {
    if (app.state !== STATES.SELECTING_FRAME) {
      return
    }

    const { x: mouseX, y: mouseY } = e.data.getLocalPosition(app.root.stage)

    const width = Math.abs(mouseX - this._mouseDownX)
    const height = Math.abs(mouseY - this._mouseDownY)
    const x = Math.min(mouseX, this._mouseDownX)
    const y = Math.min(mouseY, this._mouseDownY)
    this.frame.width = width
    this.frame.height = height
    this.frame.x = x
    this.frame.y = y
    this.frame.redraw()
    app.selectionFrame(new PIXI.Rectangle(x, y, width, height))
  }

  handleStageMouseUp = (e) => {
    if (app.state !== STATES.SELECTING_FRAME) {
      return
    }

    app.selectionFrame(null)

    const { stage } = app.root

    const $ = this.frame.ctx
    const rect = new PIXI.Rectangle($.x, $.y, $.width, $.height)

    const nodes = stage.children.filter(
      (c) => app.isNode(c) && !app.isChooseFirstStepNode(c) && c.intersectsRect(rect),
    )
    // proper cleanup to prevent render previous frame on start of next selection
    this.frame.width = 0
    this.frame.height = 0
    this.frame.redraw()
    stage.removeChild(this.frame.ctx)

    app.state = STATES.NORMAL
    this.props.onMergeSelect(nodes)
  }

  render() {
    return null
  }
}

export default connect((state) => ({
  isHeaderEditing: getUI(state).isHeaderEditing,
}))(FlowSelection)
